<template>
  <a-modal
    title="申报"
    :width="680"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok') }"
    @cancel="() => { $emit('cancel') }">
    <template slot="footer">
      <a-button key="back" @click="$emit('cancel')">
        取消
      </a-button>
      <a-button key="submit" type="primary" :loading="loading" v-if="!model" @click="$emit('ok')">
        创建
      </a-button>
      <a-button key="submit" type="primary" :loading="loading" v-if="model" @click="$emit('delete')">
        删除
      </a-button>
    </template>
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-form-item label="账册编号">
              <a-input v-decorator="['ems_no', {rules: [{required: true, message: '必填项，请填写信息'}, {max:30, message: '输入超出长度限制'}]}]" />
            </a-form-item>
            <a-form-item label="账册序号">
              <a-input v-decorator="['item_record_no', {rules: [{required: true, message: '必填项，请填写信息'}, {max:30, message: '输入超出长度限制'}]}]" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'

// 表单字段
const fields = ['id', 'ems_no', 'item_record_no']
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    return {
      form: this.$form.createForm(this)
    }
  },
  mounted () {
    // 防止表单未注册
    setTimeout(() => {
      fields.forEach(v => this.form.getFieldDecorator(v))
      // // 当 model 发生改变时，为表单设置值
      this.model && this.form.setFieldsValue(pick(this.model, fields))
      this.$watch('model', () => {
        this.model && this.form.setFieldsValue(pick(this.model, fields))
      })
    })
  }
}
</script>
